import { render, staticRenderFns } from "./EmpytState.vue?vue&type=template&id=0f51f0a8&scoped=true&"
import script from "./EmpytState.vue?vue&type=script&lang=js&"
export * from "./EmpytState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51f0a8",
  null
  
)

export default component.exports